<template>
  <BaseNoticeItem
    :button-text="$t('Enter insurance information')"
    :button-url="buttonUrl"
    status="Information missing"
    data-test="nl-insurance-alert"
  >
    <template #head>
      <strong>{{ $t('Insurance information') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'Your insurance information is required for compliance screening and will be included in Worker Classification Recommendations (WCR) on new contracts in Worksome when applicable.',
        )
      }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const { $t } = useTranslation()
const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(
    namedRoutes.frontend.user.profile.edit,
    { redirect_uri: redirectUri },
    false,
  )
  return `${path}#insurance-information`
})
</script>
